export default function FillEmpty($compile){
  return {
    restrict: "A",
    scope:{
      "fillEmpty":"="
    },
    link: function(scope, element, attr){
      if(!attr.ngRepeat){
        element.attr("ng-repeat", "i in "+attr.fillEmpty+".dummy");
        $compile(element)(scope.$parent);
      }
    }    
  }
}


// WEBPACK FOOTER //
// ./src/DataTable/FillEmpty.js